// extracted by mini-css-extract-plugin
export default {"container":"ImageWithArtistPillButton_container__0Odte","pill":"ImageWithArtistPillButton_pill__cEGoA"};